import React, { useState } from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';

const AtlasV2UnitsSold1P3PSplineChart = () => {
  const [fieldName, setFieldName] = useState('unitsSold');

  return (
    <AtlasV2ComparableSplineChart
      fieldName={fieldName}
      indexName="sales"
      singleDropdownProps={{
        defaultLabel: 'Units Sold',
        options: [
          {
            label: 'Units Sold',
            id: 'unitsSold'
          },
          {
            label: '1P Units Sold',
            id: 'onePUnitsSold'
          },
          {
            label: '3P Units Sold',
            id: 'threePUnitsSold'
          }
        ],
        selectedId: fieldName,
        onChange: (option) => setFieldName(option.id)
      }}
    />
  );
};

export default AtlasV2UnitsSold1P3PSplineChart;
